<template>
  <div class="qiankun-detail scrollbar">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'dynamicList' }">行业动态 </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span style="color: #333333; font-weight: bold">{{ data.title || '文章标题' }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content-title">
      <div class="title">{{ data.title }}</div>
      <div class="time">
        <span> <i class="iconfont icon-shijian"></i>{{ data.publishTime }} </span>
        <span><i class="iconfont icon-liulanliang"></i>{{ data.viewCount }}</span>
      </div>
      <div class="content-html">
        <div class="abstract">
          <div class="abstract-title">内容摘要</div>
          <div>{{ data.summary }}</div>
        </div>
        <div class="content" v-html="data.content"></div>
      </div>
    </div>
    <div class="bottom">
      <div v-if="contextData.pre">
        上一篇
        <span @click="toUrl(contextData.pre.id)">{{ contextData.pre.title }}</span>
      </div>
      <div v-if="contextData.next">
        下一篇
        <span @click="toUrl(contextData.next.id)">{{ contextData.next.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleDetail, getArticleAdjacentInfo } from '@/api/dynamic'
export default {
  async asyncData({ $axios, params }) {
    const url = `/services/articles/getArticleDetail/${params.id}`
    try {
      const res = await $axios.get(url)
      return {
        data: res.data.data
      }
    } catch (error) {
      console.error(error)
      return {
        data: {}
      }
    }
  },
  data() {
    return {
      id: '',
      type: '',
      data: {},
      contextData: {},
      par: {}
    }
  },
  head() {
    return {
      title: this.data.title,
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'e航无忧,海运箱货跟踪,港口信息.港区信息.船舶定位.船公司,报关,货代公司,RPA,机器人流程自动化,货代操作,货代系统,国际物流,海运查询,船期查询,货物跟踪,数据发送,舱单发送'
        },
        {
          hid: 'description',
          name: 'description',
          content: this.data.summary
        }
      ]
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.type = this.$route.params.type
    this.par = this.$route.params.par
    this.getArticleDetail()
    // this.getArticleAdjacentInfo()
  },
  methods: {
    toUrl(id) {
      if (id)
        this.$router.push({
          name: 'dynamicDetail',
          params: { id, type: this.type, par: this.par }
        })
    },

    //  获取上下文
    async getArticleAdjacentInfo() {
      let params = {
        currentPage: 1,
        pageSize: 10,
        sortByHot: true,
        id: this.id
      }
      if (this.type === 'list') {
        params = {
          id: this.id,
          ...this.par
        }
      }
      const res = await getArticleAdjacentInfo(params)
      const { data, success, msg } = res

      if (!success) return this.$message.error(msg)
      this.contextData = data
    },

    async getArticleDetail() {
      const res = await getArticleDetail(this.id)
      const { code, data, success, msg } = res
      if (code && code === 2) {
        this.$router.push({ name: 'dynamicList' })
      }
      if (!success) return this.$message.error(msg)
      this.data = data
    }
  }
}
</script>

<style lang="scss">
.qiankun-detail {
  padding: 24px 48px;
  text-align: center;
  border-right: 1px solid #f0f0f0;
  height: calc(100% - 48px);
  position: relative;

  .title {
    width: 100%;
    padding: 24px 0 16px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 28px;
    letter-spacing: 1px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }
  .time {
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    letter-spacing: 1px;
    font-family: PingFangSC-Regular, PingFang SC;
    padding-bottom: 16px;
    & > span {
      padding-right: 16px;
      .iconfont {
        font-size: 14px;
        padding-right: 8px;
      }
    }
  }
  .abstract {
    margin-bottom: 16px;
    padding: 16px 24px;
    background: #fcfcfc;
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    text-align: left;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    letter-spacing: 1px;
    .abstract-title {
      padding-bottom: 8px;
    }
  }
  .content-html {
    height: 1080px;
    overflow: auto;
  }
  .content-title {
    min-height: 80vh;
  }
  .content {
    text-align: left;
    margin-bottom: 60px;
  }
  .bottom {
    position: absolute;
    bottom: 0;
    right: 48px;
    padding: 24px 0;
    display: flex;
    justify-content: flex-end;
    & > div {
      padding-left: 16px;
      display: flex;
      & > span {
        display: block;
        width: 180px;
        padding-left: 16px;
        color: #1170eb;
        cursor: pointer;
        text-overflow: ellipsis;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
